import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'timeAgo',
    standalone: false
})
export class TimeAgoPipe implements PipeTransform {
  private readonly monthNames = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
  ];

  private readonly msPerMinute = 60 * 1000;
  private readonly msPerHour = this.msPerMinute * 60;
  private readonly msPerDay = this.msPerHour * 24;
  private readonly msPerWeek = this.msPerDay * 7;

  transform(isoTime: string, ...args: any[]): string {
    const current = new Date().getTime();
    const previous = Date.parse(isoTime);
    const elapsed = current - previous;

    if (elapsed < this.msPerMinute) {
      return 'Just now';
    } else if (elapsed < this.msPerHour) {
      const minutes = Math.floor(elapsed / this.msPerMinute);
      return minutes + this.getUnit(minutes, 'minute');
    } else if (elapsed < this.msPerDay) {
      const hours = Math.floor(elapsed / this.msPerHour);
      return hours + this.getUnit(hours, 'hour');
    } else if (elapsed < this.msPerWeek) {
      const days = Math.floor(elapsed / this.msPerDay);
      return days + this.getUnit(days, 'day');
    } else {
      const d = new Date(isoTime);
      return (
        d.getDate() +
        ' ' +
        this.monthNames[d.getMonth()] +
        ' ' +
        d.getFullYear() +
        ' at ' +
        d.toTimeString().slice(0, 5)
      );
    }
  }

  private getUnit(value: number, unit: string): string {
    if (value > 1) {
      unit = unit + 's';
    }
    return ' ' + unit + ' ago';
  }
}
